import React from 'react'

const Agenda = props => (
  <svg
    viewBox='0 0 18 20'
    width={props.width || '18px'}
    height={props.height || '20px'}
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g fill={props.color || '#333333'} fillRule='nonzero'>
        <path d='M15,2 C16.6568542,2 18,3.34314575 18,5 L18,17 C18,18.6568542 16.6568542,20 15,20 L3,20 C1.34314575,20 0,18.6568542 0,17 L0,5 C0,3.34314575 1.34314575,2 3,2 L4,2 L4,1 C4,0.44771525 4.44771525,0 5,0 C5.55228475,0 6,0.44771525 6,1 L6,2 L12,2 L12,1 C12,0.44771525 12.4477153,0 13,0 C13.5522847,0 14,0.44771525 14,1 L14,2 L15,2 Z M3,4 C2.44771525,4 2,4.44771525 2,5 L2,9 L16,9 L16,5 C16,4.44771525 15.5522847,4 15,4 L14,4 L14,5 C14,5.55228475 13.5522847,6 13,6 C12.4477153,6 12,5.55228475 12,5 L12,4 L6,4 L6,5 C6,5.55228475 5.55228475,6 5,6 C4.44771525,6 4,5.55228475 4,5 L4,4 L3,4 Z M15,18 C15.5522847,18 16,17.5522847 16,17 L16,11 L2,11 L2,17 C2,17.5522847 2.44771525,18 3,18 L15,18 Z M5,15 C4.44771525,15 4,14.5522847 4,14 C4,13.4477153 4.44771525,13 5,13 C5.55228475,13 6,13.4477153 6,14 C6,14.5522847 5.55228475,15 5,15 Z M13,13 C13.5522847,13 14,13.4477153 14,14 C14,14.5522847 13.5522847,15 13,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L13,13 Z' />
      </g>
    </g>
  </svg>
)

export default Agenda
